import type { PointStyles } from "~/types";

export default function EmojiMarker({ icon, ...props }: PointStyles) {
  const emoji = icon.replace("emoji-", "");

  return (
    <p style={{ fontSize: `${props.size}px`, lineHeight: `${props.size}px` }}>
      {emoji}
    </p>
  );
}
